import axios from 'axios'
import { Toast } from 'vant'
import CryptoJS from 'crypto-js'

import { RiskParmse, handleGetMockData, getLocalData, setLocalData, validateData } from '@/config/utils'
import { handleGetEncodeRequestParams } from '@/config/encrypt'
import { handleGetRsaSign } from '@/config/ras-sign'
import router from '../router'
import store from '../store'
import baseUrl from '../../config/dev.baseUrl'
import { openMinProgram } from '@/config/wx-min-program'
import { isMiniProgramCode } from '@/config/constants'
import logConfig from '@/config/config'
import {
  logCustomerServiceGetUserInfoError,
  logCustomerServiceGetUserInfoRequest,
  logCustomerServiceGetUserInfoResponse
} from '@/config/customer-service-get-user-info-diagnostic'
import { getChannelH5Context } from '@/config/channel-h5-return'
import { getFullPathname } from '@/config/app-base-path'

axios.defaults.baseURL = baseUrl
axios.defaults.timeout = 150000
const h5EnvData = RiskParmse()
const whiteNoLoginList = ['/lt-web/xs/member/userCouponList', '/lt-web/xs/member/raiseRecord', '/lt-web/xs/user/front/problem', '/lt-web/borrow/getProcotolInfo']
const noToastApis = ['front/problem', 'borrow/getProcotolInfo']
// 白名单类无需appInfo、token、userName
const noToken = [
  '/lt-web/assisted/full-h5/user/status',
  '/lt-web/assisted/full-h5/union-login/page',
  '/lt-web/h5/config/getPageConfig',
  '/lt-web/h5/config/getCostDisclosureContent',
  '/lt-web/h5/config/templateContent',
  '/lt-web/mini/program/half/jump/channel',
  '/lt-web/mini/program/getSchemeUrl',
  '/lt-web/xs/h5/isVerify',
  '/lt-web/xs/smsHalf/decrypt',
  '/lt-web/xs/h5/sendRgstCode',
  '/lt-web/xs/h5/captchaImage',
  '/lt-web/xs/h5/sendSms',
  '/lt-web/xs/h5/general/register',
  '/lt-web/xs/gzh/msg/sendCode',
  '/lt-web/xs/gzh/msg/bind',
  '/lt-web/xs/gzh/msg/checkBind',
  '/lt-web/xs/gzh/msg/getCreditToken'
]

const handleGoLogin = (postUrl) => {
  if (whiteNoLoginList.includes(postUrl)) return
  const time = setTimeout(() => {
    store.dispatch('native', { type: '跳登录页' }).catch(() => {
      if (isMiniProgramCode(getLocalData('lzCode'))) {
        openMinProgram('login')
      } else if (localStorage.getItem('h5LoginUrl')) {
        window.location.href = localStorage.getItem('h5LoginUrl')
      }
    })
    clearTimeout(time)
  }, 3000)
}

// 添加请求拦截器
axios.interceptors.request.use(config => {
  const envData = getLocalData('envData') || h5EnvData
  const userInfo = getLocalData('userInfo') || store.getters.userInfo || {}
  const userName = userInfo.userName || ''
  const token = userInfo.token || ''
  const lzCode = getLocalData('lzCode') === 'undefined' ? '' : getLocalData('lzCode')
  const appInfo = getLocalData('appInfo')
  const tempChannelH5Token = (getChannelH5Context() || {}).returnToken
  if (token) {
    setLocalData('userInfo', userInfo)
  }
  if (appInfo) {
    setLocalData('appInfo', appInfo)
    setLocalData('envData', getLocalData('envData'))
  }
  if (lzCode) {
    setLocalData('lzCode', lzCode)
  }
  if (!/^http/.test(config.url)) {
    const time = Date.now()
    config.headers.clientType = CryptoJS.MD5(`${time}_web`).toString()
    config.headers.webInfo = JSON.stringify({ version: 1 })
    config.headers.timestamp = time
    handleSetHeadersLinktoken(config.headers, getLocalData('h5_repay'), appInfo) // header添加linkToken
    handleSetHeadersLzCode(config.headers, lzCode, config) // header添加lzCode
    if (!noToken.includes(config.url)) {
      appInfo && (config.headers.appInfo = JSON.stringify(appInfo)) // header添加appInfo
      token && (config.headers.token = token)
    }
    if (noToken.includes(config.url)) {
      config.withCredentials = false
    }
  }
  const ContentTypeArr = ['multipart/form-data']
  if (!ContentTypeArr.includes(config.headers['Content-Type'])) { // 不是form-data类型才添加公共参数
    const queryData = (config.method === 'post' ? config.data : config.params) || {}
    // 与页面原有逻辑一致，有渠道上下文时将 token 作为业务参数参与加密和签名。
    if (config.method === 'post' && tempChannelH5Token) {
      queryData.channelH5Token = tempChannelH5Token
    }
    if (!/^http/.test(config.url) && !config.url.includes(logConfig.filterHttpUrl[0])) {
      console.warn('----- my data is request params: ', config.url, { ...queryData })
      const newQueryData = handleGetEncodeRequestParams(queryData)
      Object.keys(queryData).forEach(key => delete queryData[key])
      Object.assign(queryData, newQueryData)
    }
    // 非登录接口添加公共参数：token、userName、envData
    if (!noToken.includes(config.url)) {
      queryData.token = token
      queryData.userName = userName
      queryData.envData = envData
    }
    !/^http/.test(config.url) && (queryData.sign = handleGetRsaSign(queryData))
    if (config.method === 'post') {
      config.data = queryData
    } else {
      config.params = queryData
    }
  } else {
    config.timeout = 1000000
    config.data.append('userName', userName)
  }
  if (baseUrl === '/local/') {
    if (config.data.mkParams) {
      config.data.mkParams = JSON.stringify(config.data.mkParams)
    }
    config.data = { ...handleGetMockData(config), ...config.data }
  }
  // 在所有公共参数和签名完成后记录最终请求形态，便于比较 App WebView 与浏览器差异。
  logCustomerServiceGetUserInfoRequest(config)
  return config
}, err => {
  Toast('请求超时~')
  return Promise.resolve(err)
})

// 添加响应拦截器
axios.interceptors.response.use(res => {
  logCustomerServiceGetUserInfoResponse(res)
  if (res.status && res.status === 200 && res.data.status === 'error') {
    return
  }
  if (['10101', '1003', '1004', '1005', '1006'].includes(String(res.data.code))) {
    if (process.env.NODE_ENV !== 'development') {
      handleGoLogin(res.config.url)
    }
  }
  if (res.data.result && res.data.result.code === 1699) {
    router.push({
      name: 'vindicate',
      query: {
        startDate: res.data.result.data.startDate,
        endDate: res.data.result.data.endDate
      }
    })
  }
  return res
}, err => {
  logCustomerServiceGetUserInfoError(err)
  if (noToastApis.some(str => err.response.config.url.includes(str))) {
    return false
  }
  if (err.response.status === 504) {
    Toast('服务器正在外太空遨游，请稍后再试~')
  } else if (err.response.status === 404) {
    Toast('页面丢失，请稍后再试~')
  } else if (err.response.status === 403) {
    Toast('权限不足，请联系管理员~')
  } else if (err.response.status === 401) {
    Toast('您的请求已超时，请重新登录～')
    if ((location.pathname.split('/')).includes('treeHole')) {
      window.location.href = `${location.origin}${getFullPathname('/treeHole/tree-hole-login')}?target=${location.pathname}`
    }
    if (process.env.NODE_ENV !== 'development') {
      handleGoLogin(err.response.config.url)
    }
  } else {
    Toast('请求失败，请稍后重试~')
  }
  return Promise.reject(err)
})

// 拦截code码
export const interceptResCode = (res, resolve, reject) => {
  if (reject) return reject(res)
  resolve(res)
}
// post请求
export const postRequest = (url, params, schema) => {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      const data = (res.data && res.data.result) || res.data
      data.code !== undefined && (data.code = Number(data.code))
      if (schema) {
        validateData(schema, data)
      }
      interceptResCode(data, resolve)
    })
  })
}

// get请求
export const getRequest = (url, params) => {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: url,
      params: params
    }).then(res => {
      const data = (res.data && res.data.result) || res.data
      data.code = Number(data.code)
      interceptResCode(data, resolve)
    })
  })
}

// 文件上传
export const uploadFileRequest = (url, params, blob = false) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: blob ? 'blob' : ''
    }).then(res => {
      const data = res.response || res.data
      if (data.status === 400 && data.data.error_message) {
        interceptResCode(data.data, resolve, reject)
      } else {
        interceptResCode(res.data, resolve)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

const handleSetHeadersLinktoken = (headers, h5Repay, appInfo) => {
  let linktoken = 'h5_lt'
  if (h5Repay) {
    linktoken = 'h5_repay'
  } else if (appInfo) {
    linktoken = 'app'
  }
  headers.linktoken = linktoken
}

const handleSetHeadersLzCode = (headers, value, config) => {
  let lzCode = value
  const shouldUseRequestChannelCode = [
    '/lt-web/xs/userAuth/realNameAuthentication'
  ].includes(config.url) || location.pathname.endsWith('/unicom/channelReg')
  if (!value && shouldUseRequestChannelCode) {
    // 渠道注册和实名一推链路允许用业务渠道兜底，避免缓存偶发未恢复时后端 HeaderHandler 识别不到渠道。
    lzCode = (config.data && config.data.channelCode) || (config.params && config.params.channelCode) || ''
  }
  headers.lzCode = lzCode
}
